<div class="image" tappable #imageHolder (click)="onClick()">
  <img [src]="imageSrc" #image>
  @if (animationFinished) {
    <div class="zoom-icon">
      <cs-icon name="zoom-minus"></cs-icon>
    </div>
  }
</div>